export default "__VITE_ASSET__CX$TInMZ__"